import React from 'react';
import { Button } from '../UI/Button';
interface CommunityAccessProps {
  userLocation?: string;
}
export const CommunityAccess = ({
  userLocation = ''
}: CommunityAccessProps) => {
  const communities = [{
    name: 'Lagos Community',
    emoji: '🌆',
    link: 'https://chat.whatsapp.com/BmhDckI1FiEJxVxNUXQbKh',
    locations: ['Lagos']
  }, {
    name: 'Abuja Community',
    emoji: '🏛️',
    link: 'https://chat.whatsapp.com/KyuLep5qjEwHU6VR8tiBW9',
    locations: ['Abuja']
  }, {
    name: 'Berlin Community',
    emoji: '🇩🇪',
    link: 'https://chat.whatsapp.com/BmhDckI1FiEJxVxNUXQbKh',
    locations: ['Berlin']
  }, {
    name: 'Houston Community',
    emoji: '🇺🇸',
    link: 'https://chat.whatsapp.com/KHjjcj7M9NsBfapdZKxIDZ',
    locations: ['Houston Texas']
  }, {
    name: 'Port Harcourt Community',
    emoji: '⚓',
    link: 'https://chat.whatsapp.com/JFzBdGe9gT92ljvUSRqvhE',
    locations: ['Port Harcourt']
  }, {
    name: 'Warri Community',
    emoji: '🔥',
    link: 'https://chat.whatsapp.com/H9pJfdO1GowB5bDvB0faDO',
    locations: ['Warri']
  }, {
    name: 'UK Community',
    emoji: '🇬🇧',
    link: 'https://chat.whatsapp.com/HOoTi54Z7jYLTsfZFArTlQ',
    locations: ['UK']
  }, {
    name: 'Benin City Community',
    emoji: '🏙️',
    link: 'https://chat.whatsapp.com/BmhDckI1FiEJxVxNUXQbKh',
    locations: ['Benin City']
  }];
  // Check if user's location matches any of our communities
  const matchingCommunity = communities.find(community => community.locations.includes(userLocation));
  const hasMatchingCommunity = !!matchingCommunity;
  const isOther = userLocation === 'Other';
  return <div className="bg-white p-6 rounded-lg border-2 border-gray-300" data-id="element-99">
      <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-100">
        Welcome to The Networking Salon Community!
      </h2>
      <p className="text-gray-700 mb-8" data-id="element-101">
        The Networking Salon is designed to connect people to people, ideas, and
        opportunities. We are happy to have you join us in advancing this
        mission!
      </p>
      {hasMatchingCommunity ? <div className="mb-6" data-id="element-102">
          <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-103">
            Join the community in your city:
          </h3>
          <div className="space-y-4 border-2 border-dashed border-gray-300 p-6 rounded-lg" data-id="element-104">
            <div className="flex flex-col items-center text-center" data-id="element-105">
              <span className="text-3xl mb-3" data-id="element-106">{matchingCommunity.emoji}</span>
              <h4 className="text-lg font-bold text-gray-800 mb-2" data-id="element-107">
                {matchingCommunity.name}
              </h4>
              <p className="text-gray-600 mb-4" data-id="element-108">
                Connect with like-minded professionals in your area.
              </p>
              <a href={matchingCommunity.link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-gray-400 rounded-md bg-gray-100 hover:bg-gray-200 transition-colors" data-id="element-109">
                <span className="mr-2" data-id="element-110">👋</span>
                Join Community
              </a>
            </div>
          </div>
        </div> : isOther ? <div className="mb-8 border-2 border-dashed border-gray-300 p-6 rounded-lg text-center" data-id="element-111">
          <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-112">
            Thank you for joining our community!
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-113">
            We're thrilled to connect with you as the first member from your
            area! There's so much we want to share with you and explore how we
            can bring The Networking Salon to your city.
          </p>
          <p className="text-gray-700 mb-6" data-id="element-114">
            Click the button below to get in touch with us directly.
          </p>
          <div className="flex justify-center" data-id="element-115">
            <a href="https://wa.link/plqr43" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-gray-400 rounded-md bg-gray-100 hover:bg-gray-200 transition-colors" data-id="element-116">
              <span className="mr-2" data-id="element-117">📱</span>
              Let's Chat on WhatsApp!
            </a>
          </div>
        </div> : <div className="mb-8 border-2 border-dashed border-gray-300 p-6 rounded-lg text-center" data-id="element-118">
          <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-119">
            We couldn't find a matching community
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-120">
            It seems we don't have a community in your location yet. We'd love
            to help you connect with our global network or explore starting a
            community in your area.
          </p>
          <p className="text-gray-700 mb-6" data-id="element-121">
            Click the button below to get in touch with us directly.
          </p>
          <div className="flex justify-center" data-id="element-122">
            <a href="https://wa.link/plqr43" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-gray-400 rounded-md bg-gray-100 hover:bg-gray-200 transition-colors" data-id="element-123">
              <span className="mr-2" data-id="element-124">📱</span>
              Let's Chat on WhatsApp!
            </a>
          </div>
        </div>}
      <div className="bg-gray-100 p-4 rounded-lg" data-id="element-125">
        <p className="text-gray-700 font-medium" data-id="element-126">
          Remember to actively engage, share opportunities, and support other
          members. Together, we can build a thriving community that benefits
          everyone!
        </p>
      </div>
    </div>;
};